import { State } from "./types";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";

function handleRequest(
  state: State,
  data: Boundaries["retrieveZonesProjects"]["request"],
): State {
  return { ...state, request: setRequestStateToPending() };
}

export { handleRequest };
